import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=645edfc4&scoped=true"
import script from "./v-button.vue?vue&type=script&lang=js"
export * from "./v-button.vue?vue&type=script&lang=js"
import style0 from "./v-button.vue?vue&type=style&index=0&id=645edfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645edfc4",
  null
  
)

export default component.exports